import { FullPost, FullPromotedPost, isSubscriber } from 'model';
import { injectPromotedPosts } from '../util/injectPromotedPosts.js';
import { useEffect, useState } from 'react';
import { useGetOwnProfileQuery } from '../api/UserApi.js';
import { useCurrentUser } from './useCurrentUser.js';
import { useLoggedIn } from './useLoggedIn.js';

/**
 * Hook to inject promomted posts into the feed
 * provides stability to result in probablistic case in injectPromotedPosts
 * @param { FullPost[] | undefined | null } feed current feed
 * @param { FullPromotedPost[] | undefined | null } promoted current list of promoted messages
 * @param { number | undefined } density feedPromotionDensity setting
 * @returns { FullPost[] } the feed with promted posts added
 */
export function usePromotedFeed(
	feed: FullPost[] | undefined | null,
	promoted: FullPromotedPost[] | undefined | null,
	density?: number
): FullPost[] | null {
	const userId = useCurrentUser()?._id;
	const loggedIn = useLoggedIn();
	const { data: user } = useGetOwnProfileQuery(userId);
	const [state, setState] = useState<FullPost[] | undefined | null>(feed);
	const skipInjection = user && loggedIn.realUser && isSubscriber(user);
	const firstPromotionId = (promoted ?? [])[0]?._id;
	const firstPostId = (feed ?? [])[0]?._id;
	useEffect(() => {
		if (feed && promoted?.length && density && !skipInjection) {
			setState(injectPromotedPosts(feed, promoted, density));
		} else {
			setState(feed);
		}
		// Only inject when the length of something changes or the first item in the either changes
		// If not, then the probablistic case in injectPromotedPosts is unstable
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [feed?.length, promoted?.length, density, firstPostId, firstPromotionId, skipInjection]);

	return state ?? null;
}
